import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { LoginService } from '../services/login.service'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastService } from 'src/app/service/toast/toast.service'
import { Subject, BehaviorSubject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
    selector: 'app-agent-forgot-password',
    templateUrl: './agent-forgot-password.component.html',
    styleUrls: ['./agent-forgot-password.component.scss'],
    standalone: false
})
export class AgentForgotPasswordComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    private toaster: ToastService,
  ) {}

  forgotForm: FormGroup
  submitted = false

  email: string = ''
  code: string = ''
  private unsubscribe = new Subject()
  userCreationFail = false

  isWaitingResponse = new BehaviorSubject(false)

  ngOnInit(): void {
    this.email = this.getEmailFromUrl()
    this.code = this.getCodeFromUrl()

    this.forgotForm = this.formBuilder.group(
      {
        identifier: [this.email, [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: this.ComparePassword('password', 'confirmPassword'),
      },
    )
  }

  ComparePassword(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName]
      const matchingControl = formGroup.controls[matchingControlName]

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true })
      } else {
        matchingControl.setErrors(null)
      }
    }
  }

  newPassword() {
    this.submitted = true
    this.isWaitingResponse.next(true)
    this.userCreationFail = false

    if (this.forgotForm.invalid) {
      this.isWaitingResponse.next(false)
      return
    }

    this.loginService
      .forgotPWNewPWWebinternal(this.email, this.code, this.f.password.value)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res) => {
          this.router.navigate(['/login'])
          this.toaster.success({ message: `Password was changed for: ${this.f.identifier.value}.` })
        },
        (_) => {
          this.isWaitingResponse.next(false)
          this.userCreationFail = true

          this.toaster.error({ message: `Changing password failed: ${this.f.identifier.value}.` })
        },
      )
  }

  private getEmailFromUrl(): string {
    return this.route.snapshot.paramMap.get('email').toLowerCase()
  }

  private getCodeFromUrl(): string {
    return this.route.snapshot.paramMap.get('code')
  }

  get f() {
    return this.forgotForm.controls
  }
}
